






import { Component, Vue } from "vue-property-decorator";
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
// @ts-ignore
import SwaggerUI from "swagger-ui";
import spec from "../../assets/esim-reseller-api.yaml";
import rawSpec from "../../assets/esim-reseller-api.yaml?raw";
import "swagger-ui/dist/swagger-ui.css";

@Component({
    components: { DefaultLayout }
})
export default class APISpecifications extends Vue {
    created() {
        document.title = process.env.VUE_APP_THEME_TITLE + " | " + this.$t("apiSpecs.pageTitle");
    }
    mounted() {
        const specName = `gigastore-${spec.info.version}.yaml`;

        const downloadSpec = () => {
            const blob = new Blob([rawSpec], { type: "application/yaml" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = specName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        };

        const DownloadPlugin = function() {
          return {
            wrapComponents: {
              InfoContainer: (Original: any, { React }: any) => (props: any) => {
                return React.createElement("div", null,
                  React.createElement(Original, props),
                  React.createElement("div", { className: "info", style: { marginBottom: "25px" } },
                    React.createElement("span", null, "OpenAPI Specification: "),
                    React.createElement("a", { href: "#", className: "base-url", onClick: downloadSpec }, `[ ${specName} ]`)
                  )
                );
              }
            }
          };
        };

        SwaggerUI({
            spec: spec,
            dom_id: "#swagger",
            plugins: [ DownloadPlugin ],
            supportedSubmitMethods: ["get", "head"]
        });
    }
}
